import { SUCCESSFUL_GET_PAYMENTPLAN, UPDATE_SALEORDER } from "./actionConst";

const initialState = {
    quotas: [],
    saleOrder: {
        id: 0,
        name: ""
    }
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SUCCESSFUL_GET_PAYMENTPLAN:
            return {
                ...state,
                quotas: action.payload
            }
        case UPDATE_SALEORDER:
            return {
                ...state,
                saleOrder: Object.assign({}, action.payload)
            }
        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/paymentplan/paymentplanReducer.js